import { SESSION_TABS } from "../../constants";
import { useFeatureFlags } from "../../context/FeatureFlagsContext";
import ClassicAssistant from "../assistant/classic/Assistant";
import AgenticAssistant from "../assistant/agentic/Assistant";
import ActionItems from "../insights/actionItems/ActionItems";
import Agenda from "../insights/agenda/Agenda";
import ComingSoon from "../../components/ComingSoon";

/**
 * SessionView - Renders the content for the active session based on the selected tab.
 * The assistant variant (classic vs agentic) is selected by the `isAgentic` flag.
 * The tab header is rendered by Home.jsx.
 *
 * Session identity, the viewer alias and the live RTMS status come from SessionContext, and the
 * tab-gating feature flags from FeatureFlagsContext, so neither is drilled through here.
 */
const SessionView = ({
  isAgentic,
  selectedTab,
  showBanner,
  setShowBanner,
  chatMessages,
  setChatMessages,
  isChatLoading,
  setIsChatLoading,
  enabledAgentIds,
  availableExtensions,
  onAgentsRefreshed,
  publishedContentStore,
  insightStore,
  inviteeAliases,
  externalInvitees,
}) => {
  const featureFlags = useFeatureFlags();
  return (
    <>
      {selectedTab === SESSION_TABS.ASSISTANT && (
        isAgentic ? (
          <AgenticAssistant
            showBanner={showBanner}
            setShowBanner={setShowBanner}
            chatMessages={chatMessages}
            setChatMessages={setChatMessages}
            isChatLoading={isChatLoading}
            setIsChatLoading={setIsChatLoading}
            enabledAgentIds={enabledAgentIds}
            availableExtensions={availableExtensions}
            onAgentsRefreshed={onAgentsRefreshed}
            publishedContentStore={publishedContentStore}
            inviteeAliases={inviteeAliases}
            externalInvitees={externalInvitees}
          />
        ) : (
          <ClassicAssistant
            showBanner={showBanner}
            setShowBanner={setShowBanner}
            chatMessages={chatMessages}
            setChatMessages={setChatMessages}
            isChatLoading={isChatLoading}
            setIsChatLoading={setIsChatLoading}
            inviteeAliases={inviteeAliases}
            externalInvitees={externalInvitees}
          />
        )
      )}
      {selectedTab === SESSION_TABS.AGENDA && (
        featureFlags?.isAgendaEnabled
          ? <Agenda insightStore={insightStore} />
          : <ComingSoon />
      )}
      {selectedTab === SESSION_TABS.ACTION_ITEMS && (
        featureFlags?.isActionItemsEnabled
          ? <ActionItems insightStore={insightStore} />
          : <ComingSoon />
      )}
    </>
  );
};

export default SessionView;
